const scriptEl =
  document.currentScript ||
  document.querySelector('script[src*="easter-egg.js"][data-easter-egg-image]');

if (!scriptEl) {
  console.warn("Easter egg script could not find configuration.");
}

const eggImageUrl = scriptEl?.dataset?.easterEggImage;
const configuredSide = scriptEl?.dataset?.easterEggSide === "right" ? "right" : "left";
const klaviyoFormId = (scriptEl?.dataset?.easterEggKlaviyoFormId || "VsisSd").trim();
const sheetWebhookUrl = (scriptEl?.dataset?.easterEggSheetWebhook || "").trim();

/** DOM ids from your Klaviyo form (fallback if metaData keys differ). */
const KLAVIYO_FIELD_IDS = {
  firstName: "first_name_01KN31JDBZ2CH1TYMPCMH5RPKA",
  email: "email_01KN31JDCA9GTPMVM8F0ZKBVDG",
  phone: "phone_number_01KN31JDCNJ06XXWVZEBV8FANY",
};

function openKlaviyoEggForm() {
  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(["openForm", klaviyoFormId]);
}

function readDomField(id) {
  const el = document.getElementById(id);
  if (!el || typeof el.value !== "string") return "";
  return el.value.trim();
}

function fieldsFromMetaData(meta) {
  if (!meta || typeof meta !== "object") {
    return { firstName: "", email: "", phone: "" };
  }
  return {
    firstName: String(
      meta.$first_name ||
        meta.first_name ||
        meta.FirstName ||
        meta["First Name"] ||
        ""
    ).trim(),
    email: String(meta.email || meta.$email || "").trim(),
    phone: String(
      meta.phone_number || meta.$phone_number || meta.PhoneNumber || meta["Phone Number"] || ""
    ).trim(),
  };
}

function mergeFields(primary, fallback) {
  return {
    firstName: primary.firstName || fallback.firstName,
    email: primary.email || fallback.email,
    phone: primary.phone || fallback.phone,
  };
}

function postEggSubmissionToSheet(fields) {
  if (!sheetWebhookUrl) return;

  const payload = {
    firstName: fields.firstName,
    email: fields.email,
    phone: fields.phone,
    pageUrl: window.location.href
  };

  const body = JSON.stringify(payload);

  fetch(sheetWebhookUrl, {
    method: "POST",
    mode: "no-cors",
    headers: { "Content-Type": "text/plain;charset=utf-8" },
    body,
    keepalive: true,
  }).catch(() => {});
}

function onKlaviyoFormEvent(event) {
  const detail = event.detail;
  if (!detail || detail.type !== "submit") return;

  const eventFormId = String(detail.formId || detail.formID || "").trim();
  if (!eventFormId || eventFormId.toLowerCase() !== klaviyoFormId.toLowerCase()) return;

  const fromMeta = fieldsFromMetaData(detail.metaData);
  const fromDom = {
    firstName: readDomField(KLAVIYO_FIELD_IDS.firstName),
    email: readDomField(KLAVIYO_FIELD_IDS.email),
    phone: readDomField(KLAVIYO_FIELD_IDS.phone),
  };
  postEggSubmissionToSheet(mergeFields(fromMeta, fromDom));
}

if (sheetWebhookUrl) {
  window.addEventListener("klaviyoForms", onKlaviyoFormEvent);
}

const configuredVerticalPercent = Number.parseInt(scriptEl?.dataset?.easterEggVerticalPercent || "50", 10);
const verticalPercent = Math.min(100, Math.max(0, Number.isNaN(configuredVerticalPercent) ? 50 : configuredVerticalPercent));

if (eggImageUrl) {
  const pageHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  const eggCenterY = Math.round((pageHeight * verticalPercent) / 100);

  const trigger = document.createElement("button");
  trigger.type = "button";
  trigger.className = "easter-egg-hunt-link";
  trigger.setAttribute("aria-label", "Open Easter egg form");

  const slideInX = configuredSide === "left" ? 30 : -30;
  const hiddenTransform = "translateY(-50%) translateX(0) scale(1)";
  const revealedTransform = `translateY(-50%) translateX(${slideInX}px) scale(1.5)`;

  const baseStyle = {
    position: "absolute",
    width: "40px",
    zIndex: "20",
    display: "block",
    opacity: "0.9",
    top: `${eggCenterY}px`,
    transform: hiddenTransform,
    transformOrigin: "center center",
    transition: "transform 260ms ease-out",
  };

  if (configuredSide === "left") {
    Object.assign(baseStyle, {
      left: "-20px",
    });
  } else {
    Object.assign(baseStyle, {
      right: "-20px",
    });
  }

  Object.assign(trigger.style, baseStyle, {
    margin: "0",
    padding: "0",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    font: "inherit",
    color: "inherit",
    lineHeight: "0",
  });

  const img = document.createElement("img");
  img.src = eggImageUrl;
  img.alt = "Easter Egg";
  img.title = "Click me to enter competition!";
  img.width = 40;
  img.loading = "lazy";
  img.decoding = "async";
  img.style.width = "40px";
  img.style.display = "block";

  trigger.appendChild(img);
  document.body.appendChild(trigger);

  trigger.addEventListener("click", openKlaviyoEggForm);

  const revealEgg = () => {
    trigger.style.transform = revealedTransform;
  };

  const hideEgg = () => {
    trigger.style.transform = hiddenTransform;
  };

  trigger.addEventListener("mouseenter", revealEgg);
  trigger.addEventListener("mouseleave", hideEgg);
  trigger.addEventListener("focus", revealEgg);
  trigger.addEventListener("blur", hideEgg);
} else {
  // Image is required so the hidden egg stays on-brand.
  console.warn("Easter egg target path matched, but no egg image is configured.");
}
